/*src/modules/finance/components/CompanyGuard.tsx*/
import React from 'react';
import type { ReactNode } from 'react';
import { useAuth } from '../../../contexts/AuthContext';
import BlockedPage from '../../../pages/BlockedPage'; 

interface CompanyGuardProps {
  children: ReactNode;
}

const CompanyGuard: React.FC<CompanyGuardProps> = ({ children }) => {
  const { user, loading } = useAuth();
  const status = user?.companyStatus || user?.company?.status || 'active';

  // 1. Tela de Carregando (discreta)
  if (loading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-slate-50 dark:bg-slate-800 gap-4">
        <div className="w-8 h-8 border-2 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  // 2. Bloqueio
  if (status === 'blocked' || status === 'pending_payment') {
    return <BlockedPage />;
  }

  // 3. Acesso Liberado (Sem bordas, sem debug)
  return <>{children}</>;
};

export default CompanyGuard;
